<template>

    <div>

        <div class="listing">
            <div class="listing__nav">
                <div class="container">
                    <div class="row">
                        <div class="filter-wrap kdgjkfg">

                            <form class="form-inline" v-on:submit.prevent="searchData(search)">
                                <div class="col-lg-2 col-sm-12 col-md-4">
                                    <!--                                    <div class="form-group">-->
                                    <!--                                        <label>Staus</label><br>-->
                                    <!--                                        <select class="form-control" v-model="search.status">-->
                                    <!--                                            <option v-for="option in statusOptions" v-bind:value="option.value">-->
                                    <!--                                                {{ option.text }}-->
                                    <!--                                            </option>-->
                                    <!--                                        </select>-->
                                    <!--                                    </div>-->
                                </div>

                            </form>

                        </div>
                        <div class="col-sm-12">
                            <div class="table-wrap table-responsive">
                                <table class="table table-bordered table-hover table-condensed-xs" cellspacing="0"
                                       cellpadding="0">
                                    <thead>
                                    <tr>
                                        <!--<th scope="col"><input type="checkbox" value=""></th>-->
                                        <th scope="col">Name</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Phone</th>
                                        <th scope="col">Created At</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="careers.length == 0">No Record Found</tr>
                                    <tr v-for="career in careers.data">

                                        <td>{{career.name}}</td>
                                        <td>{{career.email}}</td>
                                        <td>{{career.phone}}</td>
                                        <td>{{career.created_at}}</td>
                                        <td>
                                            <div class="btn-group">
                                                <a class="btn btn-xs btn-default dropdown-toggle fa fa-caret-down"
                                                   data-toggle="dropdown" href="#"></a>
                                                <ul class="dropdown-menu dropdown-menu-right">
                                                    <li>
                                                        <!--                                                        <a :href="adminUrl+'/catalog/career/'+career.id"><i-->
                                                        <!--                                                                class="fa fa-info fa-fw"></i> Detail</a>-->

                                                        <a :href="adminUrl+'/careers/careers/'+career.id+'/edit'"
                                                           target="_blank"><i
                                                                class="fa fa-info fa-fw"></i> Detail</a>
                                                    </li>
                                                    <li>
                                                        <a target="_blank" :href="url+'/career/print/'+career.id"><i
                                                                class="fa fa-print" aria-hidden="true"></i> Print
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#" v-on:click="deleteCareer(career.id)"><i
                                                                class="fa fa-trash"></i>
                                                            Delete
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <pagination :data="careers" @pagination-change-page="getResults"
                                            :limit="-1"></pagination>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'

    import VueSweetalert2 from 'vue-sweetalert2';

    Vue.use(VueSweetalert2);

    import VueToast from 'vue-toast-notification';
    import 'vue-toast-notification/dist/index.css';


    Vue.component('pagination', require('laravel-vue-pagination'));

    export default {
        components: {},
        data: function () {
            return {
                careers: [],
                career: {},
                search: null,
            }
        },
        methods: {
            getData() {
                let that = this;
                console.log(process.env.MIX_API_URL);

                axios.get(process.env.MIX_API_URL + '/careers')
                    .then(function (response) {
                        that.careers = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },

            deleteCareer(id) {

                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {

                        let t = this;
                        axios.delete(process.env.MIX_API_URL + '/careers/' + id)
                            .then(function (response) {
                                t.getData();

                                Vue.$toast.open({
                                    message: response.data,
                                    type: "success",
                                    duration: 5000,
                                    dismissible: true
                                })


                                console.log(response.data);

                            })
                            .catch(function (error) {
                                this.$swal('Cancelled', 'Some error found', 'info')
                                console.log(error);
                            })
                            .then(function () {
                            });
                    } else {

                    }
                })


            },
            searchData(data) {
                console.log(data);
                let that = this;
                axios.get(url + '/career-search/' + that.search)
                    .then(function (response) {
                        // handle success
                        console.log(response);
                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error);
                    })
                    .finally(function () {
                        // always executed
                    });

            },
            getResults(page) {
                if (typeof page === 'undefined') {
                    page = 1;
                }
                let that = this;

                axios.get(process.env.MIX_API_URL + '/careers?page=' + page)
                    .then(function (response) {
                        that.careers = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });

            },

        },
        mounted: function () {
            this.getData();
        },
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },
            adminUrl: function () {
                return process.env.MIX_ADMIN_URL_DASHBOARD;
            }

        }
    }

</script>
